'use client';

import Image from 'next/image';
import React, { useContext } from 'react';

import { useGetLocationPermissionStatus } from '@/shared/hooks';
import { blurDataURL } from '@/shared/lib';
import { LoadingSpinner } from '@/shared/ui';

import { ClinicsContext } from '..';

import CategoryFilter from './CategoryFilter';
import ComboboxComponent from './ComboboxComponent';
import NotFoundOrganizations from './NotFoundOrganizations';

export default function TextContainer() {
  const { clinicsCount, isLoading } = useContext(ClinicsContext);
  const { status, grantGeoAccess } = useGetLocationPermissionStatus();

  const grant = () => {
    grantGeoAccess();
  };

  const count = () => (isLoading ? <LoadingSpinner size={5} /> : clinicsCount);

  return (
    <>
      <article className="container m-auto max-w-2xl space-y-6 px-4 text-center">
        <h1 className="text-3xl font-bold">
          Ветеринарные клиники Беларуси: адреса, часы работы, отзывы
        </h1>
        <Image
          className="my-8 rounded-md border-2 border-gray-600 drop-shadow-md"
          src="/cat-clinics.jpg"
          alt="cat"
          width={1920 / 3}
          height={1280 / 3}
          quality={isLoading ? 10 : 70}
          placeholder="blur"
          blurDataURL={blurDataURL}
          sizes="(max-width: 768px) 40vw, 45vw"
          priority
        />
        <article className="space-y-4">
          <p>
            На этой странице вы найдете адреса, часы работы и отзывы о ветеринарных клиниках в
            каждом городе Республики Беларусь.
          </p>
          <p>
            Информация обновляется регулярно, поэтому вы всегда можете быть уверены в ее
            актуальности.
          </p>
          <p>
            Чтобы найти нужную клинику, воспользуйтесь поиском по городу. Вы также можете
            ознакомиться со списком всех клиник в Беларуси, отсортированным по городу.
          </p>
        </article>
      </article>
      <hr
        className={`my-12 h-0.5 border-t-0 bg-neutral-400 opacity-100 dark:bg-neutral-100 dark:opacity-50`}
      />
      <div className="w-full flex-col gap-6 md:inline-flex md:flex-row">
        <ComboboxComponent isLoading={isLoading} />
        <CategoryFilter />
      </div>
      <h2 className="text-left text-2xl font-bold sm:text-3xl">Ближайшие к Вам организации</h2>
      <h3 className="inline-flex h-4 w-full items-center text-left text-xl font-bold">
        {'Найдено: '} {count()}
      </h3>
      {status === 'denied' && clinicsCount && (
        <div className="max-w-lg space-y-4 text-left">
          <p className="text-xs">
            Для того, чтобы мы могли показывать организации в Вашем городе пожалуйста разрешите
            доступ к геололокации и перезагрузите страницу. В данный момент Вы видите организации по
            умолчанию.
          </p>
          <button
            onClick={grant}
            className="w-fit transform rounded-sm bg-yellow-300 px-4 py-3 transition-transform active:scale-95 dark:bg-yellow-600"
          >
            Подтвердить
          </button>
        </div>
      )}
      <NotFoundOrganizations />
    </>
  );
}
